import React from 'react'
import { l } from '@manychat/manyui'

import { typedRouting } from 'utils/router'

import cm from './common.module.css'

export const WABannedNotification = () => {
  const navigate = typedRouting.useNavigate()

  const handleGoToWASettingsPage = () => navigate.settings({ hash: 'whatsApp/account' })

  return (
    <div>
      {l.translate('Your WhatsApp account has been banned by Meta. WhatsApp channel is disabled.')}{' '}
      <a onClick={handleGoToWASettingsPage} className={cm.link}>
        {l.translate('Learn More')}
      </a>
    </div>
  )
}
